import { Injectable, Inject } from "@angular/core";
import { Store } from "@ngrx/store";
import { AppState } from "../models/app.state";
import { ENV_VARS } from "../environment-variables/environment-variables.module";
import { HttpClient } from "@angular/common/http";
import * as ManualItemActions from "../store/actions/manual-item.actions";
import { FhirService } from "./fhir.service";
import { v4 } from "uuid";
import { IManualItem, ManualItem } from "../models/manual-item";
import { UserState } from "../store/reducers/user.reducer";
import { ConfigState } from "../store/reducers/config.reducer";
import { Observable } from "rxjs/Observable";
import { HttpParams } from "@angular/common/http";

export interface INotificationLogEvent {
  id: number;
  notification_type: 'EBOKS' | 'SMS';
  notification_target: string;
  reason: 'PRO_TASK_INITIAL_NOTIFICATION' | 'PRO_TASK_REMINDER_NOTIFICATION';
  zit_status_code: '200' | '500';
  published: string;
  is_dummy_notification: 1 | 0
}

@Injectable()
export class NotificationLogService {
  logEndpoint: string;
  userState: UserState;
  configState: ConfigState;
  constructor(
    public http: HttpClient,
    @Inject(ENV_VARS) public envVars,
    private store: Store<AppState>
  ) {
    this.logEndpoint = envVars.API_URL + "/@notification-log";
    this.store
      .select(state => state.user)
      .subscribe(userState => (this.userState = userState));
    this.store
      .select(state => state.config)
      .subscribe(configState => (this.configState = configState));
  }

  getLogs(taskId: string): Observable<INotificationLogEvent[]> {
    const params = {
      task_fhir_id: taskId,
      organization_uuid: this.userState.organizationUuid
    };
    Object.keys(params).forEach(key =>
      params[key] === undefined ? delete params[key] : {}
    );
    const httpParams = new HttpParams({ fromObject: params });
    return this.http.get<INotificationLogEvent[]>(this.logEndpoint, { params: params });
  }
}



// WEBPACK FOOTER //
// ./src/app/services/notification-log.service.ts